/**
 * Google Reviews Continuous Marquee Scroll
 * Smooth left-to-right continuous animation with seamless loop
 */

(function() {
  'use strict';

  function initMarquee() {
    const carousel = document.querySelector('.trustify-review-google .splide__list');
    const track = document.querySelector('.trustify-review-google .splide__track');
    
    if (!carousel || !track) {
      setTimeout(initMarquee, 500);
      return;
    }

    const slides = carousel.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    if (slides.length === 0) return;

    const slideWidth = slides[0].offsetWidth + 16;
    const totalWidth = slideWidth * slides.length;

    // Disable Splide's autoplay
    try {
      const splideInstance = document.querySelector('.trustify-review-google .splide');
      if (splideInstance && splideInstance.splide) {
        splideInstance.splide.Components.Autoplay.pause();
      }
    } catch (e) {}

    carousel.style.transition = 'none';
    
    // Speed: lower = slower (try 20-30 for slow, 50-80 for medium)
    const speed = 45;
    const duration = totalWidth / speed;

    const styleSheet = document.createElement('style');
    styleSheet.id = 'marquee-animation-styles';
    styleSheet.textContent = `
      @keyframes marquee-scroll-ltr {
        0% {
          transform: translateX(-${totalWidth}px);
        }
        100% {
          transform: translateX(0px);
        }
      }
      
      .trustify-review-google .splide__list {
        animation: marquee-scroll-ltr ${duration}s linear infinite !important;
        will-change: transform;
      }
      
      .trustify-review-google .splide__list:hover {
        animation-play-state: paused !important;
      }
      
      .trustify-review-google .splide__arrows {
        display: none !important;
      }
      
      .trustify-review-google .splide__track {
        overflow: hidden;
      }
      
      .trustify-review-google .splide__slide {
        flex-shrink: 0;
      }
    `;
    
    const existingStyle = document.getElementById('marquee-animation-styles');
    if (existingStyle) {
      existingStyle.remove();
    }
    
    document.head.appendChild(styleSheet);

    // Add clones at the END for seamless loop (reviews appear from right)
    const existingClones = carousel.querySelectorAll('.marquee-clone');
    existingClones.forEach(clone => clone.remove());
    
    // Clone all slides and append to end
    slides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('splide__slide--clone', 'marquee-clone');
      clone.removeAttribute('id');
      carousel.appendChild(clone);
    });

    // FIX: Re-attach click handlers to ALL "More" buttons (including clones)
    fixMoreButtons();

    console.log('Google Reviews marquee initialized - left-to-right scroll active');
  }

// Function to make "More" buttons work on cloned slides
  function fixMoreButtons() {
    const allMoreButtons = document.querySelectorAll('.trustify-review-google .trgg-text-collapse__more');
    
    allMoreButtons.forEach(function(btn) {
      // Remove any existing listeners by cloning and replacing
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      // Track state with data attribute - starts as false (collapsed)
      newBtn.setAttribute('data-expanded', 'false');
      
      // Add click handler
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = this.closest('.trgg-text-collapse');
        if (container) {
          const holder = container.querySelector('.trgg-text-collapse__holder');
          if (holder) {
            const isExpanded = this.getAttribute('data-expanded') === 'true';
            
            if (!isExpanded) {
              // EXPAND: Show full text
              holder.classList.add('trgg-text-collapse__holder--hidden');
              holder.classList.remove('trgg-text-collapse__holder--hide');
              this.textContent = 'Less';
              this.setAttribute('data-expanded', 'true');
            } else {
              // COLLAPSE: Hide text back
              holder.classList.remove('trgg-text-collapse__holder--hidden');
              holder.classList.add('trgg-text-collapse__holder--hide');
              this.textContent = 'More';
              this.setAttribute('data-expanded', 'false');
            }
            
            // Force button to stay visible
            this.style.display = 'inline-block';
            this.style.visibility = 'visible';
            this.style.opacity = '1';
          }
        }
      });
      
      // Also add touch handler for mobile
      newBtn.addEventListener('touchend', function(e) {
        e.preventDefault();
        this.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initMarquee, 1000);
    });
  } else {
    setTimeout(initMarquee, 1000);
  }

  window.addEventListener('shopify:section:load', function() {
    setTimeout(initMarquee, 1000);
  });

})();